module.exports = "/lucky-balls/img/regular_game/header_dualsoft.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_dualsoft.png
// module id = 1144
// module chunks = 0